export function MailIcon({ size = 16 }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" aria-hidden="true" className="shrink-0">
      <rect x="3" y="5.5" width="18" height="13" stroke="currentColor" strokeWidth="1.2" />
      <path d="M3.5 6.5 L12 13 L20.5 6.5" stroke="currentColor" strokeWidth="1.2" />
    </svg>
  );
}

export function PhoneIcon({ size = 16 }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" aria-hidden="true" className="shrink-0">
      <path
        d="M6.8 3.5h2.4l1.6 4-2 1.4a10.4 10.4 0 0 0 4.9 4.9l1.4-2 4 1.6v2.4c0 1-.8 1.9-1.9 1.8C9.6 17 5 12.4 4.5 5.4c-.1-1 .8-1.9 1.8-1.9Z"
        stroke="currentColor"
        strokeWidth="1.2"
        strokeLinejoin="round"
      />
    </svg>
  );
}
